const VuexTypes = Object.freeze({
  ADV_INVOICES_LIST: 'ADV_INVOICES_LIST',
  ADV_INVOICES_LIST_FILTERS: 'ADV_INVOICES_LIST_FILTERS',
  ADV_INVOICE_CLASSIFIERS: 'ADV_INVOICE_CLASSIFIERS',
  ADV_INVOICE_UPDATE_DATA: 'ADV_INVOICE_UPDATE_DATA',
  ADV_INVOICE_MEDIA_LIST: 'ADV_INVOICE_MEDIA_LIST',
  ADV_INVOICE_CREATE: 'ADV_INVOICE_CREATE',
  ADV_INVOICE_UPDATE: 'ADV_INVOICE_UPDATE',
  ADV_INVOICE_DELETE_ATTACHMENT: 'ADV_INVOICE_DELETE_ATTACHMENT',
  ADV_INVOICE_UPDATE_STATUS: 'ADV_INVOICE_UPDATE_STATUS',
  ADV_INVOICE_PAYMENT_APPROVE: 'ADV_INVOICE_PAYMENT_APPROVE',
  ADV_INVOICE_PAYMENT_REJECT: 'ADV_INVOICE_PAYMENT_REJECT',
  ADV_INVOICE_ACTIVITY: 'ADV_INVOICE_ACTIVITY',
  ADV_INVOICE_DELETE: 'ADV_INVOICE_DELETE',
  UPDATE_NEW_ADV_INVOICE_FILES: 'UPDATE_NEW_ADV_INVOICE_FILES',
});

export default VuexTypes;
